export default __webpack_public_path__ + "static/media/jm-jp-pump.69ef406a.png";